module.exports = __webpack_public_path__ + "img/telegram@2x.78fdb75b.png";